<div class="flex flex-col gap-2">
  @for (strategy of strategies(); track strategy.strategyId) {
    <div class="flex rounded-lg border px-4 py-2 shadow-xs">
      <app-strategy-link [strategyId]="strategy.strategyId!" [withCampaignType]="true" />
    </div>
  }
</div>
